/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostDigitalSovereigntyAlmadarProposalENPostPage
 */

import { useAlmadarPostDigitalSovereigntyAlmadarProposalENPostPageLogic } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalENPostPageLogic';
import type { AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageConfig } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostDigitalSovereigntyAlmadarProposalENPostView as AlmadarPostDigitalSovereigntyAlmadarProposalENPostViewEntity } from '@app/shared';
import { Container } from '@almadar/ui/components';
import { AlmadarPostDigitalSovereigntyAlmadarProposalENPostFooterView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalENPostFooterView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalENPostView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalENPostView';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostDigitalSovereigntyAlmadarProposalENPostHeaderView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalENPostHeaderView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageViewProps {
  config?: Partial<AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageConfig>;
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView({ config: propsConfig }: AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostDigitalSovereigntyAlmadarProposalENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostDigitalSovereigntyAlmadarProposalENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostDigitalSovereigntyAlmadarProposalEN" trait="AlmadarPostDigitalSovereigntyAlmadarProposalENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostDigitalSovereigntyAlmadarProposalENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostDigitalSovereigntyAlmadarProposalENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box paddingY="xl" bg="transparent" fullWidth={true}><Container maxWidth="xl" padding="lg" size="xl"><AlmadarPostDigitalSovereigntyAlmadarProposalENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostDigitalSovereigntyAlmadarProposalENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView;
